import { configureStore } from "@reduxjs/toolkit";
import quizReducer from "./slices/QuizQuestionReducer";
import quizResultsReducer from "./slices/QuizResultsReducer";

export default configureStore({
    reducer: {
        quiz: quizReducer,
        quizResults: quizResultsReducer,
    },
});